module.exports = __webpack_public_path__ + "img/stripe.9bacf7ff.png";